import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-center gap-2 py-10"
}
const _hoisted_2 = { class: "font-medium" }
const _hoisted_3 = {
  key: 1,
  class: "py-10 text-center"
}
const _hoisted_4 = { class: "text-sm text-red-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_CustomButton = _resolveComponent("CustomButton")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('views.farmToFarm.loading')), 1),
        _createVNode(_component_Spinner, { class: "w-5 h-5" })
      ]))
    : (_ctx.isError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('views.farmToFarm.loadError')), 1),
          _createVNode(_component_CustomButton, {
            class: "mt-4 max-w-32",
            "color-preset": "secondary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('retry')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('views.farmToFarm.retry')), 1)
            ]),
            _: 1
          })
        ]))
      : _renderSlot(_ctx.$slots, "default", { key: 2 })
}